/**
 * Ayuda — Compras → Cuentas Corrientes
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PUR_ACCOUNTS_ITEM = {
  id: 'accounts',
  screenId: 'adm-pur-accounts',
  label: 'Cuentas Corrientes',
  description: 'Consultá cuentas corrientes y lo pendiente de pago a proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá ves la deuda y los movimientos con tus proveedores en cuenta corriente, y los remitos que todavía no se facturaron. Tiene cuatro pestañas arriba; tocá cada una para cambiar de vista.',
      },
      {
        title: 'Las cuatro pestañas',
        bullets: [
          'Cuentas Corrientes — historial del proveedor (facturas, pagos, notas) con saldo acumulado.',
          'Facturas Pendientes — facturas que aún no pagaste por completo.',
          'Saldos Pendientes — resumen de cuánto debés a cada proveedor.',
          'Remitos sin Facturar — remitos que todavía tienen mercadería o cantidades sin facturar.',
        ],
      },
      {
        title: 'Pestaña Cuentas Corrientes',
        fields: [
          { label: 'Proveedor', description: 'Buscá y elegí el proveedor. Es obligatorio.' },
          {
            label: 'Tipo de Cuenta',
            description: '«Actual» al día de hoy. «A fecha» para ver la cuenta hasta una fecha elegida.',
          },
          { label: 'Fecha (solo en «A fecha»)', description: 'Hasta qué día calcular movimientos y saldos.' },
          { label: 'Buscar', description: 'Carga movimientos y totales por moneda.' },
        ],
        paragraphs: [
          'Arriba ves el saldo por moneda (por ejemplo ARS 50000).',
          'Cada fila: fecha, descripción, moneda, importe y saldos acumulados.',
          'Tocá una fila para abrir la factura o el comprobante de pago.',
        ],
      },
      {
        title: 'Pestaña Facturas Pendientes',
        fields: [
          { label: 'Proveedor (opcional)', description: 'Vacío = todos; o elegí uno.' },
          { label: 'Tipo de Cuenta', description: '«Actual» o «A fecha».' },
          { label: 'Ordenado Por', description: 'Por Fecha o por Monto pendiente.' },
          { label: 'Buscar', description: 'Lista y total pendiente por moneda.' },
        ],
        bullets: [
          'Columnas: Fecha, Descripción, Moneda, Monto, Pagado y Saldo pendiente.',
          'Tocá una fila para ver el detalle de la factura.',
        ],
      },
      {
        title: 'Pestaña Saldos Pendientes',
        intro:
          'Al entrar se carga sola la lista de proveedores con deuda y el monto por moneda. Arriba ves los totales generales. No hace falta buscar: es un panorama rápido de a quién debés y cuánto.',
        bullets: ['Columnas: Proveedor, Moneda, Monto pendiente.'],
      },
      {
        title: 'Pestaña Remitos sin Facturar',
        intro:
          'Al entrar se carga la lista de remitos que todavía tienen cantidades sin facturar. Podés dejar los filtros vacíos para verlos todos, o acotar la búsqueda.',
        fields: [
          {
            label: 'Proveedor (opcional)',
            description: 'Dejalo vacío para ver remitos de todos los proveedores, o elegí uno.',
          },
          {
            label: 'Fecha Desde / Fecha Hasta (opcionales)',
            description: 'Limitá el período del remito. Podés usar solo una de las dos fechas.',
          },
          {
            label: 'Buscar',
            description: 'Vuelve a cargar la lista con los filtros elegidos.',
          },
        ],
        bullets: [
          'Columnas: Fecha, Proveedor, Comprobante, Moneda e Importe.',
          'El importe es lo que queda por facturar (cantidad pendiente por precio de cada línea).',
          'Si el remito no tiene precios cargados, el importe dice «Sin precio». Si solo algunas líneas tienen precio, el importe dice «(parcial)».',
          'Arriba ves el total valorizado por moneda. Los remitos sin precio no entran en ese total.',
          'Tocá una fila para abrir el remito.',
        ],
      },
    ],
  },
}
